import { Record } from 'immutable';

export const PreferenceTypes = Object.freeze({
  SYSTEM: 'SYSTEM',
  USER: 'USER',
});
// eslint-disable-line no-undef

export const DataTypes = Object.freeze({
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
});
// eslint-disable-line no-undef

export const mkPreferenceV2 = Record({
  clientId: undefined,
  id: undefined,
  isDeleted: undefined,
  preferenceType: undefined,
  name: undefined,
  dataType: undefined,
  label: undefined,
  value: undefined,
});

export const mkPreferenceCriteria = Record({
  clientId: undefined,
  id: undefined,
  isDeleted: undefined,
  preferenceName: undefined,
  value: undefined,
  rollOutTarget: undefined,
  criteriaType: undefined,
  rollOutType: undefined,
  client: undefined,
  datasetPlatform: undefined,
});
